import { RelayEnvironmentProvider } from "react-relay";
import { StateHost } from "../app-controller/StateHost";
import { AppServiceContext } from "../app-controller/AppServiceContext";
import { DeviceInfoContext } from "../app/DeviceInfo";
import { HotkeysProvider } from "@blueprintjs/core";
import { appService, deviceInfo, environment } from "../relay/environment";

export function RootLayout() {
  return (
    <DeviceInfoContext.Provider value={deviceInfo}>
      <HotkeysProvider>
        <RelayEnvironmentProvider environment={environment}>
          <AppServiceContext.Provider value={appService}>
            <StateHost />
          </AppServiceContext.Provider>
        </RelayEnvironmentProvider>
      </HotkeysProvider>
    </DeviceInfoContext.Provider>
  );
}
